/*
 * @Author: Chu Yifei
 * @LastEditors: Chu Yifei
 */
export function wordNumFormat(words, num) {
  return words.length >= num ? `${words.slice(0, num)}...` : words
}
